<template>
    <v-card flat>
        <v-overlay :value="loadingUserData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar color="bal-gray" dense>
            <v-toolbar-title
                >{{ activeUser.first_name ? `${activeUser.first_name} ${activeUser.last_name}` : "-" }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="bal-red" dark @click="editUser">
                <v-icon>edit</v-icon>
                {{ "Edit" | t }}
            </v-btn>
            <v-menu bottom left offset-y v-if="user.role === 'admin'">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="px-2 ml-2 mx-2" color="bal-dark-gray" dark style="min-width: 0;">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="handleDeleteClick">
                        <v-list-item-title style="color: red">{{ "Delete" | t }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn icon @click="closeDrawer()">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "User info" | t }}
            </v-tab>
            <v-tab-item>
                <div class="pa-5">
                    <v-row>
                        <v-col class="col-item row-title" cols="3">{{ "First name" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUser.first_name ? activeUser.first_name : "-" }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-item row-title" cols="3">{{ "Last name" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUser.last_name ? activeUser.last_name : "-" }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-item row-title" cols="3">{{ "Email" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUser.email ? activeUser.email : "-" }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-item row-title" cols="3">{{ "Phone number" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUser.phone_number ? activeUser.phone_number : "-" }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-item row-title" cols="3">{{ "Status" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUser.user_status ? activeUser.user_status : "-" }}
                        </v-col>
                        <v-btn
                            v-if="show_resend_button && activeUser.user_status === 'pending'"
                            @click="handleResendActivationClick"
                            >{{ "Resend activation" | t }}
                        </v-btn>
                    </v-row>
                    <v-row>
                        <v-col class="col-item row-title" cols="3">{{ "Locale" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUser.locale ? activeUser.locale.toUpperCase() : "-" }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-item row-title" cols="3">{{ "Capabilities" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUser.capabilities ? activeUser.capabilities : "-" }}
                        </v-col>
                    </v-row>
                    <div
                        v-if="
                            activeUser &&
                                activeUser.user_companies &&
                                activeUser.user_companies.length > 0 &&
                                user.role === 'admin'
                        "
                    >
                        <div v-for="company in activeUser.user_companies" :key="company.id">
                            <v-divider class="mt-3 mb-3"/>
                            <v-row>
                                <v-col class="col-item row-title" cols="3">{{ "Company name" | t }}</v-col>
                                <v-col class="col-item" cols="6">
                                    {{ company.name ? company.name : "-" }}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="col-item row-title" cols="3">{{ "Company role" | t }}</v-col>
                                <v-col class="col-item" cols="6">
                                    {{ company.role ? company.role : "-" }}
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </div>
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Store from "../../store";

export default {
    name: "user-view",
    components: {},
    data() {
        return {
            tab: 0,
            tabs: ["General info", "Integration info", "Contact info"],
            show_resend_button: true
        };
    },
    computed: {
        ...mapState(["activeUser", "loadingUserData", "activeCompany", "user"])
    },
    async mounted() {
        document.addEventListener("keydown", this.nextTab);
        await this.getUserData(this.$route.params.userId);
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
        if (this.activeUser.company_id) {
            await this.getCompanyData(this.activeUser.company_id);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.nextTab);
    },
    methods: {
        ...mapActions(["getUserData", "getCompanyData"]),
        closeDrawer() {
            this.$router.push({ name: "users-list" });
        },
        editUser() {
            this.$router.push({
                name: "user-edit",
                params: { userId: this.$route.params.userId, tab: this.tabs[this.tab] }
            });
        },
        nextTab(e) {
            if (e.keyCode === 69 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.editUser();
            }
            if (e.key === "ArrowLeft") {
                if (this.tab > 0) {
                    this.tab -= 1;
                }
            } else if (e.key === "ArrowRight") {
                if (this.tab + 1 < this.tabs.length) {
                    this.tab += 1;
                }
            }
        },
        async handleDeleteClick() {
            if (confirm("Are you sure you want to delete this user?")) {
                const response = await Store.dispatch("deleteUser", {
                    user_id: this.activeUser.id
                });
                if (response && response.status === 1) {
                    await this.$router.push({
                        name: "users-list"
                    });
                    await Store.dispatch("getUsers");
                    await Store.commit("setRequestSuccess", true);
                } else {
                    await Store.commit("setRequestError", true);
                    await Store.commit("setErrorMessage", "Failed");
                }
            }
        },
        async handleResendActivationClick() {
            const result = await Store.dispatch("resendActivationLink", this.activeUser);
            if (result && result.success === 1) this.show_resend_button = false;
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
